module.exports = __webpack_public_path__ + "icon_arrow_normal.36388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_arrow_normal.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_arrow_normal.svg
// module chunks = main